import closeIco from '@assets/generalItems/deleteCrossGray.png'
import { useLinkedContext } from '@context/LinkedItemZoneContext'
import * as Dialog from '@radix-ui/react-dialog'
import { VisuallyHidden } from '@radix-ui/react-visually-hidden'
import { useAppStore } from '@store'
import { Store } from '@types'
import { ReactNode } from 'react'

type Props = {
  children: ReactNode
  closeFn: () => void
}

export function LinkedEditorWrapper({ children, closeFn }: Props) {
  const textos = useAppStore.use.textos()
  const { selectedTexture, modelo } = useLinkedContext()

  const closeModal = useAppStore((s) => s.closeModal)
  // const objectName = useAppStore(
  //   (s) =>
  //     s.items.get(s.currentObjectID)?.description ?? s.areas.get(s.currentObjectID)?.description,
  // )

  function t(str: string) {
    if (!textos.textos) return str
    if (!(str in textos.textos)) return str
    const str2 = str as unknown as keyof Store['textos']['textos']
    return textos.textos[str2]
  }

  return (
    <Dialog.Content
      onInteractOutside={(e) => {
        e.preventDefault()
        e.stopPropagation()
      }}
    >
      <VisuallyHidden>
        <Dialog.Title>Linked Editor</Dialog.Title>
      </VisuallyHidden>
      <Dialog.Description>Dialog content for Linked Editor</Dialog.Description>
      <Dialog.Overlay className='white-background absolute bottom-0 left-0 right-0 top-0 m-auto h-[720px] w-[1450px] grid-cols-2 content-center overflow-hidden rounded-xl bg-C/Color1'>
        <Dialog.Close className='absolute right-3 top-3 z-[100] cursor-pointer'>
          <img
            className='h-2.5'
            src={closeIco}
            onClick={(e) => {
              closeModal()
              closeFn()
            }}
          />
        </Dialog.Close>
        <div className='relative ml-0 mt-0 grid h-[720px] grid-cols-[1.15fr_3fr] rounded-xl border-2 border-C/Color3'>
          <section className='relative flex items-center justify-between border-r-2 border-white bg-C/Color3 py-1.5 text-sm font-bold text-C/Color1'>
            <div className='ml-2 flex-1 text-left'>{'Zona '}</div>
            <div className='absolute left-1/2 top-1/2 ml-[98px] h-8 w-[2px] -translate-x-1/2 -translate-y-1/2 transform bg-white'></div>
            <div className='ml-52 max-w-[275px] flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-left'>
              {'Selecciona Material'}
            </div>
          </section>
          <section className='bg-C/Color3 py-1.5 pl-2 text-sm font-bold text-C/Color1'>
            {'Selecciona Acabados'}
            {['Tirador', 'Encimera'].includes(modelo) ? (
              ` | ${modelo}`
            ) : (
              <>
                {selectedTexture?.zoneDisplayName && ` | ${t(selectedTexture.zoneDisplayName)}`}
                {selectedTexture?.acabado && ` | ${t(selectedTexture.acabado)}`}
                {selectedTexture?.name && ` | ${t(selectedTexture.name)}`}
              </>
            )}
          </section>
          {children}
        </div>
      </Dialog.Overlay>
    </Dialog.Content>
  )
}
